var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorTriangleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Error triangle filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.15363 20.7184C2.06652 20.1164 1.67324 18.7472 2.2752 17.6601L10.032 3.65179C10.2365 3.28242 10.5409 2.97806 10.9102 2.77349C11.9972 2.1714 13.3665 2.56452 13.9686 3.65156L21.7276 17.6598C21.9124 17.9935 22.0093 18.3686 22.0093 18.75C22.0093 19.9926 21.002 21 19.7593 21L4.24358 21C3.86227 21 3.48721 20.9031 3.15363 20.7184ZM12.002 16.0037C11.4504 16.0037 11.0033 16.4508 11.0033 17.0024C11.0033 17.5539 11.4504 18.001 12.002 18.001C12.5535 18.001 13.0006 17.5539 13.0006 17.0024C13.0006 16.4508 12.5535 16.0037 12.002 16.0037ZM11.9998 8C11.487 8.00018 11.0645 8.38638 11.0069 8.88373L11.0002 9.00037L11.002 14.0013L11.0088 14.1179C11.0667 14.6152 11.4895 15.0011 12.0024 15.0009C12.5152 15.0007 12.9377 14.6145 12.9953 14.1172L13.002 14.0005L13.0002 8.99963L12.9934 8.88303C12.9355 8.38571 12.5127 7.99982 11.9998 8Z",
    fill: "#F68900"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTriangleFilled);
export default __webpack_public_path__ + "static/media/error_triangle_filled.dde26106e8602fac44b6e8ba2d73481c.svg";
export { ForwardRef as ReactComponent };